import { render, staticRenderFns } from "./DepartmentForm.vue?vue&type=template&id=bdd06db0&scoped=true&"
import script from "./DepartmentForm.vue?vue&type=script&lang=js&"
export * from "./DepartmentForm.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentForm.vue?vue&type=style&index=0&id=bdd06db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd06db0",
  null
  
)

export default component.exports